import { render, staticRenderFns } from "./RandomRoute.vue?vue&type=template&id=0d25eaf5&"
import script from "./RandomRoute.vue?vue&type=script&lang=js&"
export * from "./RandomRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports